import { title } from "../global";

export default function Navbar(props) {

    return (<div className='navbar'>
        <div className='navbar-title'>
            {title}
        </div>
    </div>)
}